import React from 'react'
import 'animate.css';
import ScrollAnimation from 'react-animate-on-scroll';
import CountUp from 'react-countup';
// import LogoIcon from '../assets/logo1.webp';
import BannerRight from '../assets/banner-right.jpeg';
import WebDev from '../assets/web-dev.svg';
import SwDev from '../assets/sw-dev.svg';
import AppDev from '../assets/app-dev.svg';
import GraphicDes from '../assets/graphic-des.svg';
import AboutImg from '../assets/about-img.jpg';
import Billing from '../assets/billing.jpg';
import Hotel from '../assets/hotel.jpg';
import Mlm from '../assets/mlm.png';
import Face from '../assets/face.jpg';
import Salon from '../assets/product/salon2.png';
import School from '../assets/product/school2.png';
import WhyChoose from '../general/WhyChoose';
import { useNavigate } from 'react-router-dom';

const Home = () => {

    const navigate = useNavigate();

    return (
        <>
            {/* banner section */}
            <section className='banner-bg'>

                <div className='row'>

                    <div className='col-lg-7 col-md-7 col-12 my-2'>
                        <div className='banner-left'>
                            <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Welcome to Dectwin Services</p>
                            <p className='banner-heading'>Empowering Businesses Through <span className='text-blue'>Customized Solutions</span></p>
                            <p className='fw-semibold text-muted'>We are Dectwin Services Pvt Ltd specialized in providing Software & Web Solutions to built your presence online and ease business workflow</p>

                            <button className='banner-btn1' onClick={() => navigate('/services')}>View Services</button>&nbsp;&nbsp;
                            <button className='banner-btn2' onClick={() => navigate('/contact')}>Get In Touch</button><br />
                        </div>
                    </div>
                    {/* left ends */}

                    <div className='col-lg-5 col-md-5 col-12 my-2 align-content-center text-end px-lg-0 px-md-0 ps-4'>
                        <img src={BannerRight} className='banner-right-img img-fluid' alt='Banner Right' />
                    </div>

                </div>
                {/* row ends */}

            </section>
            {/* banner section ends */}


            {/* Our services section */}
            <section className='my-5'>
                <div className='container text-center py-lg-5'>

                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> What we Offer?</p>
                    <p className='sec-heading'>Best IT Services in Prayagraj</p>

                    <ScrollAnimation animateIn='fadeInUp' className='row'>

                        <div className='col-lg-3 col-md-6 col-12 my-2'>
                            <div className='service-area'>
                                <img src={SwDev} className='service-img my-3' alt='Service' />
                                <p className='service-text'>Software Development</p>
                                <p className='service-info'>Creating, testing, & maintaining softwares, ensuring functionality, performance, and scalability to meet user requirements has made us the best software company in Prayagraj.</p>
                                <button className='banner-btn2'  onClick={() => window.open('https://wa.me/8707510135?text=Hey!%20Dectwin%20Services.%20Want%20to%20know%20about%20Software%20Development%20Services.', '_blank')}>Enquire Now</button>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-12 my-2'>
                            <div className='service-area' >
                                <img src={WebDev} className='service-img my-3' alt='Service' />
                                <p className='service-text'>Web Development</p>
                                <p className='service-info'>We provide custom website, ecommerce website development services in Prayagraj delivering user-friendly, responsive, and visually appealing interfaces.</p>
                                <button className='banner-btn2' onClick={() => window.open('https://wa.me/8707510135?text=Hey!%20Dectwin%20Services.%20Want%20to%20know%20about%20Web%20Development%20Services.', '_blank')}>Enquire Now</button>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-12 my-2'>
                            <div className='service-area'>
                                <img src={AppDev} className='service-img my-3' alt='Service' />
                                <p className='service-text'>App Development</p>
                                <p className='service-info'>We use technologies to build natively compiled applications for mobile, web, and desktop providing exclusive mobile application development services near you.</p>
                            <button className='banner-btn2' onClick={() => window.open('https://wa.me/8707510135?text=Hey!%20Dectwin%20Services.%20Want%20to%20know%20about%20Applicatino%20Development%20Services.', '_blank')}>Enquire Now</button>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-12 my-2'>
                            <div className='service-area' >
                                <img src={GraphicDes} className='service-img my-3' alt='Service' />
                                <p className='service-text'>Graphic Design</p>
                                <p className='service-info'>Creating visually captivating designs for branding, marketing, and digital platforms, we have best branding & top marketing strategies to build your solid digital presence.</p>
                            <button className='banner-btn2' onClick={() => window.open('https://wa.me/8707510135?text=Hey!%20Dectwin%20Services.%20Want%20to%20know%20about%20Graphice%20Designing%20Services.', '_blank')}>Enquire Now</button>
                            </div>
                        </div>


                    </ScrollAnimation>
                    {/* row ends */}

                </div>
            </section>
            {/* Our services section ends */}


            {/* about section */}
            <section className='py-4 px-lg-4 px-2'>
                <div className='bg-light rounded-4 px-lg-5 px-3 py-5'>

                    <div className='row'>

                        <div className='col-lg-6 col-md-9 col-12 my-2 about-left'>
                            <div className='about-left-area'>
                                <p className='my-0 fs-4 text-blue fw-bold'><CountUp end={90} duration={4} enableScrollSpy={true} />%</p>
                                <p className='fw-semibold'>Happy Active Clients</p></div>
                            <img src={AboutImg} className='img-fluid rounded-4' alt='about left' />
                        </div>

                        <div className='col-lg-6 col-12 my-lg-2 mt-4'>
                            <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> About Us</p>
                            <p className='sec-heading'>Most Trusted Services since 2017</p>
                            <p className='text-muted fw-semibold'>We are the global software development company in George Town Prayagraj dedicated to delivering top-notch custom software & Web development services in Prayagraj with speed and excellence. Our team is committed to providing innovative solutions that meet our clients' needs and exceed their expectations.</p>

                            <div className='d-md-flex my-4'>
                                <div className='d-flex mb-2'><i class="fa-regular fa-circle-check py-2 pe-2 text-blue"></i>
                                    <p className='fs-5 fw-bold my-0'>Industry Experience<br />
                                        <span className='fs-6 fw-semibold text-muted'>Leading with 8+ years of Experience in Industry</span></p></div>
                                <div className='d-flex mb-2'><i class="fa-regular fa-circle-check py-2 pe-2 text-blue"></i>
                                    <p className='fs-5 fw-bold my-0'>Active Team<br />
                                        <span className='fs-6 fw-semibold text-muted'>Thanks to our Team who made projects deliver on time</span></p></div>
                            </div>
                            {/* flex ends */}
                            <hr />
                            <button className='banner-btn1 mt-3' onClick={() => navigate('/about')}>Know More</button>

                        </div>

                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* about section ends */}


            {/* Our products section */}
            <section className='my-5'>
                <div className='container text-center'>

                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Our Products</p>
                    <p className='sec-heading'>Discover our Exclusive Products</p>

                    <ScrollAnimation animateIn='fadeInUp' className='row mt-4 justify-content-center'>

                        <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-2'>
                            <div className='product-area'>
                                <img src={Billing} className='product-img img-fluid' alt='Billing' />
                                <div class="product-overlay" onClick={() => navigate('/billing-software')}>
                                    <i class="fa-solid fa-arrow-right product-icon"></i>
                                    <p class="product-text">Billing Software</p>
                                </div>
                                    <p class="product-text d-block d-md-none">Billing Software</p>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-2'>
                            <div className='product-area'>
                                <img src={Hotel} className='product-img img-fluid' alt='Billing' />
                                <div class="product-overlay" onClick={() => navigate('/hotel-management')}>
                                    <i class="fa-solid fa-arrow-right product-icon"></i>
                                    <p class="product-text">Hotel Management</p>
                                </div>
                                    <p class="product-text d-block d-md-none">Hotel Management</p>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-2'>
                            <div className='product-area'>
                                <img src={Mlm} className='product-img img-fluid' alt='Billing' />
                                <div class="product-overlay" onClick={() => navigate('/mlm-software')}>
                                    <i class="fa-solid fa-arrow-right product-icon"></i>
                                    <p class="product-text">MLM Software</p>
                                </div>
                                    <p class="product-text d-block d-md-none">MLM Software</p>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-2'>
                            <div className='product-area'>
                                <img src={Face} className='product-img img-fluid' alt='Billing' />
                                <div class="product-overlay" onClick={() => navigate('/face-attendance')}>
                                    <i class="fa-solid fa-arrow-right product-icon"></i>
                                    <div class="product-text">Face Attendance</div>
                                </div>
                                    <p class="product-text d-block d-md-none">Face Attendance</p>
                            </div>
                        </div>

                                                <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-2'>
                            <div className='product-area'>
                                <img src={Salon} className='product-img img-fluid' alt='Salon' />
                                <div class="product-overlay" onClick={() => navigate('/')}>
                                    <i class="fa-solid fa-arrow-right product-icon"></i>
                                    <p class="product-text">Salon Software</p>
                                </div>
                                    <p class="product-text d-block d-md-none">Salon Software</p>
                            </div>
                        </div>

                                                                        <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-2'>
                            <div className='product-area'>
                                <img src={School} className='product-img img-fluid' alt='Salon' />
                                <div class="product-overlay" onClick={() => navigate('/')}>
                                    <i class="fa-solid fa-arrow-right product-icon"></i>
                                    <p class="product-text">School Management Software</p>
                                </div>
                                    <p class="product-text d-block d-md-none">School Management Software</p>
                            </div>
                        </div>


                    </ScrollAnimation>
                    {/* row ends */}

                </div>
            </section>
            {/* Our products section ends */}


            {/* Contact section */}
            <section className='py-4 px-lg-4 px-2'>
                <div className='bg-dark rounded-4 px-lg-5 px-3 py-5 text-white'>

                    <div className='row'>

                        <div className='col-lg-6 col-md-6 col-12 my-2'>
                            <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Contact Us</p>
                            <p className='sec-heading'>Let's Discuss your Project</p>

                            <p className='fw-semibold'>Struggling with Online presence and challenges in Business needs. This is where Dectwin Services
                                comes in role. Discuss your requirements with us and our team will assist you. We are here to transform your ideas
                                into Software.</p>

                            <hr className='my-lg-5 my-4' />

                            <div className='d-flex justify-content-between fw-semibold'>
                                <p>Call us at:<br /><span className='fs-4'>870-751-0135</span></p>
                                <p>Follow on Social Media:<br />
                                    <span onClick={() => window.open('https://www.linkedin.com/company/dectwin-services/?viewAsMember=true', '_blank')}><i class="fa-brands my-2 about-icon fa-linkedin-in"></i></span>
                                    <span className='ms-2' onClick={() => window.open('https://www.instagram.com/dectwinservices/', '_blank')}><i class="fa-brands my-2 about-icon fa-instagram"></i></span></p>
                            </div>

                        </div>

                        <div className='col-lg-6 col-md-6 col-12 my-2'>

                            <div class="accordion accordion-flush" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        How can Dectwin help my business?
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-muted fw-semibold">
                                        Dectwin Services in Prayagraj delivers cutting-edge software solutions designed to optimize business processes, improve user experiences, and drive growth, ensuring your business stays ahead in the digital world.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        What industries does Dectwin serve?
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-muted fw-semibold">
                                        We have delivered projects across various industries, including healthcare, real estate, finance, retail, and technology, providing customized software solutions for diverse business needs.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingThree">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        How you ensure project success?
                                        </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-muted fw-semibold">
                                        We follow a structured approach, ensuring clear communication, regular updates, and thorough testing, delivering high-quality results that align with client expectations and timelines.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingFour">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                        How do I get started with Dectwin?
                                        </button>
                                    </h2>
                                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-muted fw-semibold">
                                        Getting started is easy— contact us via our website or email, and our team will schedule a consultation to discuss your project requirements and goals.                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* Contact section ends */}

<WhyChoose />

        </>
    )
}

export default Home
